import { h } from "omi";

type Props = {
  progress: number;
};

export function ProgressCircle({ progress }: Props) {
  const SIZE = 24;
  const STROKE_WIDTH = 1;
  const CENTER = SIZE / 2;
  const RADIUS = CENTER - STROKE_WIDTH / 2;

  const clampedProgress = Math.max(0, Math.min(100, progress));

  const angle = (2 * Math.PI * clampedProgress) / 100;
  const endX = CENTER + RADIUS * Math.sin(angle);
  const endY = CENTER - RADIUS * Math.cos(angle);
  const largeArcFlag = clampedProgress > 50 ? 1 : 0;

  const slicePath = `M ${CENTER} ${CENTER} L ${CENTER} ${STROKE_WIDTH / 2} A ${RADIUS} ${RADIUS} 0 ${largeArcFlag} 1 ${endX} ${endY} Z`;

  return (
    <svg className="w-full h-full text-success-400 border-0" viewBox={`0 0 ${SIZE} ${SIZE}`}>
      <circle cx={CENTER} cy={CENTER} r={RADIUS} fill="transparent" stroke="currentColor" strokeWidth={STROKE_WIDTH} />
      {clampedProgress > 0 && <path d={slicePath} fill="currentColor" />}
    </svg>
  );
}
